var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    { style: { background: _vm.background }, attrs: { id: "head_top" } },
    [
      _vm.goApp
        ? _c(
            "section",
            { staticClass: "head_goback", on: { click: _vm.goAppBack } },
            [_c("i", { staticClass: "iconfont icon-left" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.goBack
        ? _c(
            "section",
            {
              staticClass: "head_goback",
              on: {
                click: function($event) {
                  return _vm.$router.go(-1)
                }
              }
            },
            [_c("i", { staticClass: "iconfont icon-left" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.headTitle
        ? _c("section", { staticClass: "title_head ellipsis" }, [
            _c("span", { staticClass: "title_text" }, [
              _vm._v(_vm._s(_vm.headTitle))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.share
        ? _c(
            "section",
            { staticClass: "head_share", on: { click: _vm.appShare } },
            [_c("i", { staticClass: "iconfont icon-fanhuianniu" })]
          )
        : _c("section", { staticClass: "head_share" }),
      _vm._v(" "),
      _vm._t("msite-title")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ea43a02", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ea43a02","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compontents/headView.vue
// module id = 8Nle
// module chunks = 0